import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;

const state = {
  linkToken: null, // LINEアカウント連携用のTOKEN
  tokenExpired: false // LINEアカウント連携用のTOKENが有効期限切れしているか
};

const getters = {
  getLinkToken: state => state.linkToken,
  getTokenExpired: state => state.tokenExpired
};

const actions = {
  async fetchLinkTokenExpired({ commit, state }) {
    return $axios
      .get(axiosBase.getUrls().linkTokenExpired, {
        params: { linkToken: state.linkToken }
      })
      .then(res => {
        if (res.data) {
          state.tokenExpired = true;
          return Promise.reject({
            message: "ページの有効期限が切れています。恐れ入りますが、友達追加からやり直してください。"
          });
        } else {
          state.tokenExpired = false;
          return Promise.resolve(true);
        }
      })
      .catch(error => {
        state.tokenExpired = true;
        if (error.message) {
          return Promise.reject(error.message);
        }

        if (error.response) {
          if (error.response.status === 400) {
            return Promise.reject(error.response.data.message);
          }
          return Promise.reject("サーバーエラーが発生しました。しばらく経ってからもう一度お試しください。");
        }
        return Promise.reject("ネットワークエラーが発生しました。接続を確認してください。");
      });
  }
};

const mutations = {
  writeLinkToken(state, token) {
    console.log(token);
    state.linkToken = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
